/**
 * 顶部导航组件切图
 * */ 
export const NAVIGATION_HEADER_IMAGES = {
  back: 'https://p0.meituan.net/pepperfe/08f0e414a83dbe77e425a11d60adb742482.png',
  location: 'https://p0.meituan.net/pepperfe/ba7726ecbdb4dd6158419541a8580f6a358.png',
  search: 'https://p1.meituan.net/pepperfe/5ac7d1899676203eb1bd21952a6963831337.png',
}

/**
 * 骨骼Logo
*/
export const SKELETON_LOGO_URL = 'https://p1.meituan.net/pepperfe/465f59407a9b3a0f2bf1456445f3c2fa7554.png';